import { gql } from '@apollo/client';
import { CHANNEL } from '../../../components/myeirconstant/myEirConstant';

const ENDPOINT = {
    GET_PAYMENT_PROVIDER: gql`
        query getPaymentProvider($accountId: String!, $channel: ChannelType!) {
            getPaymentProvider(accountId: $accountId, channel: $channel) {
                paymentProvider
            }
        }
    `,
};

/**
 * @name getPaymentProvider - to get an payment provider(Eg ELAVON,STANCER)
 * @param {Object} Obj - attributes for the function
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 * @returns {string} Promise resolves in to payment provider
 */
export const getPaymentProvider = async ({ graphql }) => {
    try {
        const { data } = await graphql.query({
            query: ENDPOINT.GET_PAYMENT_PROVIDER,
            variables: {
                accountId: sessionStorage.getItem('LoggedinUserAccountID'),
                channel: CHANNEL,
            },
        });
        return data?.getPaymentProvider;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
